const getPhoneWithPlus = (phone: string) => {
  const hasPlus = /^\+/.test(phone);

  if (hasPlus) return phone;

  return `+${phone}`;
};

export default getPhoneWithPlus;
